import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "28760uAu9VE65FaLbIjHGzX", "MainEntrance", undefined);

import { _decorator, Component, Node, isValid, view, Camera, PhysicsSystem, Label, v3, tween, game } from 'cc';
import { E_ADUrl } from './common/ad/AdCtr';
import { E_EventType, E_GameState, E_MainLayerType } from './common/EnumBase';
import { App } from './common/manager/App';
import { E_PoolType } from './common/manager/PoolManager';
import { E_MusicType } from './common/manager/SoundManager';
import { Fail } from './Fail';
import GameScene from './GameScene';
import { GameUI } from './GameUI';
import { Gift } from './Gift';
import Hall from './Hall';
import { Set } from './Set';
import { Shop } from './Shop';
import { Win } from './Win';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var MainEntrance = (_dec = ccclass('MainEntrance'), _dec2 = property(Node), _dec3 = property(Node), _dec4 = property(Node), _dec5 = property(Node), _dec6 = property(Node), _dec7 = property(Node), _dec8 = property(Node), _dec9 = property(Node), _dec10 = property(Node), _dec11 = property(Node), _dec12 = property(Node), _dec13 = property(Node), _dec14 = property(Node), _dec15 = property(Node), _dec16 = property(Node), _dec17 = property(Node), _dec18 = property(Node), _dec19 = property(Node), _dec20 = property(Camera), _dec21 = property(Camera), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MainEntrance, _Component);

  function MainEntrance() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_hall", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_gameUI", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_gameScene", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_bg", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_set", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_msgRoot", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_preGain", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_alertLayer", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_result", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_guide", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_drawPanel", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_common", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_win", _descriptor13, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_fail", _descriptor14, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_shop", _descriptor15, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_gift", _descriptor16, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_tipRoot", _descriptor17, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_link", _descriptor18, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "cam_ui", _descriptor19, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "cam_game", _descriptor20, _assertThisInitialized(_this));

    return _this;
  }

  var _proto = MainEntrance.prototype;

  // LIFE-CYCLE CALLBACKS:
  _proto.onLoad = function onLoad() {
    if (!App.GameCtrl.checkFromURL()) {
      window.open(E_ADUrl.Dob5_URL, "_self");
      return;
    }

    view.enableAutoFullScreen(false);
    game.setFrameRate(60);
    PhysicsSystem.instance.fixedTimeStep = 1 / 60;
    PhysicsSystem.instance.resetAccumulator(0);
    App.GameCtrl.cam_ui = this.cam_ui;
    App.GameCtrl.cam_game = this.cam_game;
    App.GameCtrl.n_drawPanel = this.a_n_drawPanel;
    App.GameCtrl.n_msgRoot = this.n_tipRoot;
    App.GameCtrl.n_link = this.n_link;
    App.ResMgr.preLoad();
    App.SoundMgr.init();
    App.SoundMgr.playMusicType(E_MusicType.Hall);
    App.LocalDBMgr.init();
    App.AdCtrl.init();
  };

  _proto.start = function start() {
    App.DataMgr.calcVisibleSize();
    App.DataMgr.calcGameCamRect();
    App.DataMgr.calcGameCamSize();
    App.DataMgr.calcZMax_camGame(260);
    App.DataMgr.vBaseSize_game = App.DataMgr.vSize_game;
    App.DataMgr.zBaseIndex_game = App.GameCtrl.cam_game.node.position.z;
    App.DataMgr.rate_uiToGame = App.DataMgr.visibleSize.width / App.DataMgr.vBaseSize_game.width;
    App.DataMgr.init();
    this.addEventListenr();
    this.handleSwitch(E_MainLayerType.Hall);
  };

  _proto.onDestroy = function onDestroy() {
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {
    //重玩
    App.EventMgr.addEventLintener(E_EventType.Layer_Switch, this.handleSwitch, this);
    App.EventMgr.addEventLintener(E_EventType.Tip_Shop, this.handleTip_shop, this);
    App.EventMgr.addEventLintener(E_EventType.Tip_Msg, this.handleTip_msg, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
    App.AdEventMgr.removeEvent(this);
  };

  _proto.handleShowAlert = function handleShowAlert(type, info) {};

  _proto.handleTip_shop = function handleTip_shop(msg) {
    var n_msg = App.PoolMgr.getItem(E_PoolType.ShopTip);
    n_msg.parent = this.n_tipRoot;
    n_msg.getChildByName("lbl_name").getComponent(Label).string = msg;
    n_msg.setPosition(v3(0, 0, 0));
    tween(n_msg).by(1.5, {
      position: v3(0, 150, 0)
    }).call(function () {
      App.PoolMgr.returnItem(n_msg);
    }).start();
  };

  _proto.handleTip_msg = function handleTip_msg(msg) {
    var n_msg = App.PoolMgr.getItem(E_PoolType.MsgTip);
    n_msg.parent = this.n_tipRoot;
    n_msg.getChildByName("lbl_tip").getComponent(Label).string = msg;
    n_msg.setPosition(v3(0, 0, 0));
    tween(n_msg).by(1.5, {
      position: v3(0, 150, 0)
    }).call(function () {
      App.PoolMgr.returnItem(n_msg);
    }).start();
  };

  _proto.handleSwitch = function handleSwitch(type) {
    var _this$a_n_hall$getCom, _this$a_n_set$getComp;

    this.reset(type);

    switch (type) {
      case E_MainLayerType.Hall:
        App.GameCtrl.gameState = E_GameState.PreBegin;
        PhysicsSystem.instance.enable = false;
        PhysicsSystem.instance.fixedTimeStep = 1 / 60;
        PhysicsSystem.instance.resetAccumulator(0);
        App.GameCtrl.reset();
        App.EventMgr.handleEvent(E_EventType.Game_Reset);
        (_this$a_n_hall$getCom = this.a_n_hall.getComponent(Hall)) === null || _this$a_n_hall$getCom === void 0 ? void 0 : _this$a_n_hall$getCom.enter();
        break;

      case E_MainLayerType.Game:
        App.GameCtrl.gameState = E_GameState.Gaming;
        this.n_gameUI.getComponent(GameUI).enter();
        this.n_gameScene.getComponent(GameScene).enter();
        break;

      case E_MainLayerType.Result:
        if (App.GameCtrl.isWin) {
          var _this$n_win$getCompon;

          (_this$n_win$getCompon = this.n_win.getComponent(Win)) === null || _this$n_win$getCompon === void 0 ? void 0 : _this$n_win$getCompon.enter();
        } else {
          var _this$n_fail$getCompo;

          (_this$n_fail$getCompo = this.n_fail.getComponent(Fail)) === null || _this$n_fail$getCompo === void 0 ? void 0 : _this$n_fail$getCompo.enter();
        }

        break;

      case E_MainLayerType.Shop:
        this.n_shop.getComponent(Shop).enter();
        App.GameCtrl.isSwitch = false;
        break;

      case E_MainLayerType.Set:
        (_this$a_n_set$getComp = this.a_n_set.getComponent(Set)) === null || _this$a_n_set$getComp === void 0 ? void 0 : _this$a_n_set$getComp.enter();
        break;

      case E_MainLayerType.Gift:
        if (App.DataMgr.giftLineIndex >= 0) {
          this.n_gift.active = true;
          this.n_gift.getComponent(Gift).enter();
        }

        break;
    }
  }
  /**展示节点 */
  ;

  _proto.showNode = function showNode(path, n_attach, call) {
    var _this2 = this;

    if (n_attach && isValid(n_attach, true)) {
      call();
      return;
    }

    App.ResMgr.getPfb(path, this, function (prefab) {
      if (call) call.call(_this2, prefab);
    });
  };

  _proto.reset = function reset(type) {
    if (type == E_MainLayerType.Set) return;
    var isActive_hall = false;
    var isActive_win = false;
    var isActive_fail = false;
    var isActive_common = true;
    var isActive_shop = false;

    switch (type) {
      case E_MainLayerType.Hall:
        isActive_hall = true;
        isActive_common = true;
        break;

      case E_MainLayerType.Game:
        break;

      case E_MainLayerType.Result:
        isActive_fail = !App.GameCtrl.isWin;
        isActive_win = App.GameCtrl.isWin;
        break;

      case E_MainLayerType.Shop:
        isActive_hall = true;
        isActive_common = false;
        isActive_shop = true;
        break;

      case E_MainLayerType.Gift:
        isActive_hall = true;
        break;
    }

    this.n_win.active = isActive_win;
    this.n_fail.active = isActive_fail;
    this.a_n_hall.active = isActive_hall;
    this.n_common.active = isActive_common;
    this.n_shop.active = isActive_shop;
  };

  _proto.btn_n_logo = function btn_n_logo() {// window.open("https://www.dob5.com?from=ballsShooter", "_blank");
  };

  return MainEntrance;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "a_n_hall", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_gameUI", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "n_gameScene", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "a_n_bg", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "a_n_set", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "a_n_msgRoot", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "a_n_preGain", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "a_n_alertLayer", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "a_n_result", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "a_n_guide", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "a_n_drawPanel", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "n_common", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "n_win", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "n_fail", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "n_shop", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "n_gift", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "n_tipRoot", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "n_link", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "cam_ui", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, "cam_game", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();